import { useState } from 'react';
import { Send } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';

export default function NewsletterBlock({ compact = false }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post('/newsletter/subscribe', { email });
      toast.success(data.message);
      setEmail('');
    } catch {
      toast.error("Erreur lors de l'inscription");
    } finally {
      setLoading(false);
    }
  };

  if (compact) {
    return (
      <form onSubmit={handleSubmit} data-testid="newsletter-form-compact" className="flex gap-2">
        <input type="email" value={email} onChange={e => setEmail(e.target.value)}
          placeholder="Votre email" required data-testid="newsletter-email-compact"
          className="flex-1 glass-input rounded-xl px-3 py-2 text-white text-sm placeholder-zinc-500 focus:outline-none" />
        <button type="submit" disabled={loading} data-testid="newsletter-submit-compact"
          aria-label="S'inscrire à la newsletter"
          className="btn-primary p-2.5 rounded-xl !rounded-full w-10 h-10 flex items-center justify-center">
          <Send className="w-4 h-4" />
        </button>
      </form>
    );
  }

  return (
    <section data-testid="newsletter-block" className="py-24 md:py-32 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/[0.01] to-transparent" />
      <div className="max-w-2xl mx-auto px-6 md:px-12 text-center relative z-10">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-yellow-400 mb-3 block">Newsletter</span>
        <h2 className="font-['Outfit'] text-2xl sm:text-3xl font-bold text-white mb-3">
          Recevez nos conseils auto
        </h2>
        <p className="text-zinc-400 text-sm mb-8 leading-relaxed">
          Conseils pour vendre, acheter ou entretenir votre véhicule. Pas de spam, que du contenu utile.
        </p>
        <form onSubmit={handleSubmit} data-testid="newsletter-form" className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <input type="email" value={email} onChange={e => setEmail(e.target.value)}
            placeholder="Votre adresse email" required data-testid="newsletter-email"
            className="flex-1 glass-input rounded-xl px-4 py-3.5 text-white text-sm placeholder-zinc-500 focus:outline-none" />
          <button type="submit" disabled={loading} data-testid="newsletter-submit"
            className="btn-primary py-3.5 px-6 text-sm neon-glow-hover disabled:opacity-50">
            {loading ? 'Envoi...' : "S'inscrire"}
          </button>
        </form>
      </div>
    </section>
  );
}
